import { useAppTheme } from "@hooks/useAppTheme";
import { useGlobalStore } from "@hooks/useGlobalStore";
import { Switch } from "react-native-paper";

const AudioPlaybackTestSwitch = () => {
	const theme = useAppTheme();
	const showAudioPlaybackTestDialog = useGlobalStore(
		(state) => state.showAudioPlaybackTestDialog,
	);
	const toggleAudioPlaybackTestDialog = useGlobalStore(
		(state) => state.toggleAudioPlaybackTestDialog,
	);

	return (
		<Switch
			value={showAudioPlaybackTestDialog}
			onChange={(e) => {
				e.stopPropagation();
				toggleAudioPlaybackTestDialog();
			}}
			color={theme.colors.secondary}
		/>
	);
};

export default AudioPlaybackTestSwitch;
